export class ProgramProductRequest {
   programId: number = 0;
   patientId: string = "";
   programCaseID: string = "";
   programProductId: string = "";
   enrollmentSource: string = "";
   programIdentifier: string = "";
   ndc: string = "";
   icd: string = "";
   productFamily: string = "";
   activeDate: string = "";
   inActiveDate: string = "";
   dateObtainedFromPayerSPP: string = "";
   insurerRequiredCopay: string = "";
   oopMaxMet: string = "";
   oopMaximum: string = "";
   priorAuthorizationDate: string = "";
   priorAuthorizationNumber: string = "";
}